import React from "react";

const PhoneMockup = ({ src, alt = "VÉLIS app", className = "", float = true, width = 240 }) => {
  return (
    <div
      className={`phone-frame ${float ? "velis-float" : ""} ${className}`}
      style={{ width: `${width}px` }}
    >
      <div className="phone-notch" />
      <div className="phone-inner">
        <img src={src} alt={alt} loading="lazy" />
      </div>
    </div>
  );
};

export default PhoneMockup;
